export enum FiltersName {
  StartDate = 'startDate',
  EndDate = 'endDate',
  OriginSubject = 'originSubject',
  Keyname = 'keyname',
  OrderDirection = 'orderDirection',
  OrderProp = 'orderProp'
}
